import { takeLatest, put, call } from 'redux-saga/effects'
import { UPDATE_TUTOR, UPDATE_TUTOR_FAIL, UPDATE_TUTOR_SUCCESS, UpdateTutorActionType } from '../redux/tutorReducer'
import apiCall from '../helpers/apiCall'

function* UpdateTutorFlow(action: UpdateTutorActionType): Generator<any, void, any> {
  try {
    const response = yield call(apiCall, {
      endpoint: '/tutors/tutors',
      method: 'PUT',
      params: { tutor: action.payload }
    })
    yield put(UPDATE_TUTOR_SUCCESS(response))
  } catch (error) {
    yield put(UPDATE_TUTOR_FAIL())
    console.log(error)
  }
}

export default function* UpdateTutorSaga(): Generator<any, void, any> {
  yield takeLatest([UPDATE_TUTOR], UpdateTutorFlow)
}
